// common business logic related util methods
import axios from "axios";
import { baseUrl } from "../config/config";

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
  // Staff-console calls opt out of the impersonation header. /api/platform is
  // explicitly not a school surface, and a request that carries "act as this
  // school" while asking a cross-organisation question is contradicting itself.
  // Without this, opening the console while god mode happened to be left on
  // would silently tag every platform read with a school it has nothing to do
  // with — which is the exact confusion the separate route tree exists to end.
  ignoreImpersonation = false,
}) {
  // Check for God Mode - add impersonated school ID to headers
  const impersonatingSchool = ignoreImpersonation ? null : localStorage.getItem("impersonating_school");
  if (impersonatingSchool) {
    try {
      const school = JSON.parse(impersonatingSchool);
      if (school._id) {
        headers["x-impersonate-school"] = school._id;
      }
    } catch (e) {
      // Invalid JSON, ignore
    }
  }

  const reqObj = {
    method,
    url: baseUrl + path,
    headers,
  };

  reqObj.params = queryParams;

  // Only set JSON content-type if not FormData (let browser set multipart boundary)
  if (!(postData instanceof FormData) && !reqObj.headers["Content-Type"]) {
    reqObj.headers["Content-Type"] = "application/json";
  } else if (postData instanceof FormData) {
    delete reqObj.headers["Content-Type"];
  }

  if (["POST", "PUT", "PATCH", "DELETE"].includes(method)) {
    reqObj.data = postData;
  }

  let results;

  try {
    results = await axios(reqObj);
    return results?.data;
  } catch (error) {

    if (error?.response?.status === 401 && !error?.response?.data?.requiresActivation) {
      localStorage.clear();
      window.location.reload();
    }

    return {
      code: error?.response?.status,
      message: error?.response?.data?.message ? error.response?.data?.message : "",
    };
  }
}
